import { restClient } from '@/Core'

import { toUploadSession } from '../Helpers/diskResponse'
import { DISK_UPLOAD_REQUEST_TIMEOUT_MS } from './UploadDiskFileTask'

import type { DiskUploadSession } from '../Contracts/DiskUpload'

/**
 * Шматок `n` (з 0) сирими байтами: `PUT /services/disk/uploads/{uuid}/chunks/{n}`.
 * Розмір — точно `chunkSize`, останній — залишок; повтор того самого номера
 * бек приймає без шкоди.
 */
export const PutDiskUploadChunkTask = async (
    uuid: string,
    number: number,
    chunk: Blob,
    signal?: AbortSignal
): Promise<DiskUploadSession> => {
    const response = (await restClient.put(`/services/disk/uploads/${encodeURIComponent(uuid)}/chunks/${number}`, {
        body: chunk,
        headers: { 'Content-Type': 'application/octet-stream' },
        timeout: DISK_UPLOAD_REQUEST_TIMEOUT_MS,
        ...(signal ? { signal } : {}),
    })) as unknown

    return toUploadSession(response)
}
